import mqtt from "mqtt/dist/mqtt.min.js"; // 引入mqtt依赖
import store from "@/store/index.js";
import request from "@/assets/js/request.js";
import { i18n } from '@/i18n';
import CONFIG from '@/assets/js/config';
import { Message } from "element-ui";

var client; // mqtt客户端
let mqttConfig; // 业务配置对象
let publishTopic = null; // 订阅topic
let retryTimer = null; // 用于保存当前重试定时器
let cacheRetryTask = null; // 用于保存当前 retryMqttCache 的 abort 方法
let cacheRefreshTimer = null; // 每3分钟定时刷新缓存定时器
let networkStatus = true; // 网络状态，默认为在线
let reconnectTimer = null; // 网络重连定时器
let messageCallback = null; // 外部消息回调

//  默认配置
const MQTT_OPTIONS = {
  // connectTimeout: 5000, // 连接超时时间
  clientId: "clientId-statistic-" + Math.random(), // clientId不能重复，这里可以随机生成
  username: "admin", // 用户名
  password: null, // 密码-调后端接口拿字段token
  clean: true, // 是否清除会话
  reconnectPeriod: 5000, // 每隔5s尝试重连一次
  keepalive: 120,
};

/**
 * 设置消息回调函数
 * @param {function} fn - 外部传入的消息处理回调
 */
export function setMqttStatisticCallback(fn) {
  messageCallback = fn;
}

/**
 * 初始化 MQTT 连接（统计页面专用）
 * @param {object} config - 设备四要素 { pn, sn, devcode, devaddr }
 */
export function initMqttStatistic(config) {
  // 构造mqtt配置对象
  mqttConfig = {
    ...config,
    // serviceCode: 2,
    serviceCode: 8,
  };

  // 移除之前的网络状态监听
  delStatisticNetworkListener();

  // 添加网络状态监听
  addNetworkListener();

  // 调取后端接口获取密码和topic主题
  request
    .postMicroserDess("/relay-ess/api/mqtt/getTopic", {
      pn: mqttConfig.pn,
      sn: mqttConfig.sn,
      devcode: mqttConfig.devcode,
      devaddr: mqttConfig.devaddr,
      serviceCode: mqttConfig.serviceCode,
    })
    .then((res) => {
      // 获取到主题和密码
      publishTopic = res.data.topic;
      MQTT_OPTIONS.password = res.data.token;
      console.log(MQTT_OPTIONS, "=====mqttStatistic=====");
      console.log("mqttStatistic初始化开始");

      // 兼容H5（web）
      // 根据环境选择协议：development 使用 ws，其他环境使用 wss
      const mqttProtocol = CONFIG.env === "development" ? "ws://" : "wss://";
      client = mqtt.connect(
        mqttProtocol + CONFIG.MQTT_IP,
        // "wss://" + "api.test.valueclouds.com/mqtt",
        // "ws://" + "47.107.128.73:8093/mqtt",
        MQTT_OPTIONS,
        function (err) {
          console.log(err);
          console.log(publishTopic);
        },
      );

      // 连接mqtt服务器
      mqttConncat();
    });
}

// 连接mqtt服务器并监听
function mqttConncat() {
  // 移除已有监听器避免重复绑定
  client.removeAllListeners();
  // 绑定监听事件
  setupMqttEventListeners();
}

// 设置MQTT事件监听器
function setupMqttEventListeners() {
  client
    .on("connect", handleConnect)
    .on("reconnect", logReconnect)
    .on("error", logError)
    .on("end", logDisconnect)
    .on("close", logClose)
    .on("offline", logOffline)
    .on("disconnect", (packet) => {
      console.log("【disconnect】", packet);
    })
    .on("packetreceive", (packet) => {
      if (["connack", "disconnect"].includes(packet.cmd)) {
        console.log("【收到包】", packet.cmd, packet);
      }
    })
    .on("packetsend", (packet) => {
      if (["connect", "pingreq"].includes(packet.cmd)) {
        console.log("【发送包】", packet.cmd, packet);
      }
    });
}

// 处理连接成功事件
function handleConnect() {
  console.log("mqttStatistic连接成功");
  if (!client) return;
  if (typeof publishTopic === "string" && publishTopic.trim()) {
    // 订阅主题
    client.subscribe(publishTopic, function (err) {
      if (!err) {
        console.log("mqttStatistic已成功订阅主题:", publishTopic);

        if (typeof mqttListen === "function") {
          mqttListen(() => {
            // 在这里处理业务功能
            cacheRetryTask = retryMqttCache(mqttConfig, 5, 5000);
            cacheRetryTask.promise
              .then(() => {})
              .catch(() => {
                mqttStatisticDisconnect();
              });
            // 连接成功后启动定时刷新
            startCacheRefreshTimer();
          });
        }
      } else {
        console.error("mqttStatistic订阅主题失败:", err);
      }
    });
  }
}

function retryMqttCache(config, retryCount = 5, interval = 5000) {
  let abortRequested = false;
  const task = new Promise((resolve, reject) => {
    const attempt = (remainingRetries) => {
      if (abortRequested) return;

      // 如果客户端不存在或已断开，终止重试
      if (!client || !client.connected) {
        console.log("MQTT 已断开，停止重试");
        return;
      }

      request
        .postMicroserDess("/relay-ess/api/mqtt/cache", config)
        .then((res) => {
          console.log(res, "mqttStatistic cache config");
          if (res.code === 0) {
            store.commit("changeMqttStatus", true);
            resolve(res); // 成功，直接 resolve
          } else if (remainingRetries > 1) {
            console.log(
              `失败，${interval / 1000}s 后重试...剩余次数：${
                remainingRetries - 1
              }`,
            );
            retryTimer = setTimeout(() => {
              attempt(remainingRetries - 1);
            }, interval);
          } else {
            console.error("已达最大重试次数，连接监控失败");
            reject(res); // 最终失败，reject
          }
        })
        .catch((err) => {
          if (abortRequested) return;
          console.error("请求异常:", err);
          reject(err);
        });
    };

    attempt(retryCount);
  });

  const abort = () => {
    abortRequested = true;
    if (retryTimer) {
      clearTimeout(retryTimer);
    }
    console.log("MQTT Cache 重试已中止");
  };

  // 暴露 promise 和 abort 方法供外部控制
  return {
    promise: task,
    abort,
  };
}

// 监听mqtt消息
function mqttListen(callback) {
  console.log("mqttStatistic监听器启动");
  // 监听消息
  client.on("message", function (topic, message) {
    const res = JSON.parse(message.toString());
    console.log(res, "mqttStatistic数据");
    if (res.code === 0) {
      // 解析消息数据，通过回调函数通知外部
      const redata = typeof res.data === 'string' ? JSON.parse(res.data) : res.data;
      if (typeof messageCallback === "function") {
        messageCallback(redata);
      }
      // const result = dataProcess(crownRecordFlowDat.spFlowDat.pars);
      // store.commit("saveFlowDataS", result);
      // store.commit("saveFlowResData", crownRecordFlowDat.flowDat);
      // store.commit(
      //   "saveTimeInformation",
      //   formatDate(new Date(crownRecordFlowDat.flowDat.date)),
      // );
    } else {
      // 处理离线业务
      cacheRetryTask = retryMqttCache(mqttConfig, 5, 5000);
      cacheRetryTask.promise
        .then(() => {})
        .catch(() => {
          Message.warning(i18n.t('device.Device_Offline'));
          // Message.warning("设备离线");
          mqttStatisticDisconnect();
        });
    }
  });
  // 监听器绑定完成，调用回调
  if (typeof callback === "function") {
    callback();
  }
}

// 启动每3分钟定时调用 retryMqttCache（直接使用模块级 mqttConfig，避免陈旧引用）
export function startCacheRefreshTimer() {
  clearCacheRefreshTimer(); // 先清除已有定时器
  cacheRefreshTimer = setInterval(() => {
    // 如果客户端不存在或已断开，或配置不存在，终止重试
    if (!client || !client.connected || !mqttConfig) {
      console.log("MQTT 已断开或配置缺失，停止重试");
      return;
    }
    console.log("定时刷新：调用 retryMqttCache");
    const task = retryMqttCache(mqttConfig, 1);
    task.promise
      .then(() => {})
      .catch(() => {
        console.log("定时刷新 retryMqttCache 失败");
      });
  }, 3 * 60 * 1000); // 3分钟
  // }, 20000); // 3分钟
}

// 清除定时刷新缓存定时器
export function clearCacheRefreshTimer() {
  if (cacheRefreshTimer) {
    clearInterval(cacheRefreshTimer);
    cacheRefreshTimer = null;
    console.log("retryMqttCache 定时器已清除");
  }
}

// 断开连接
export function mqttStatisticDisconnect() {
  console.log("mqttStatistic触发了断开");
  if (client) {
    // client.removeAllListeners();
    client.end(true);
    client = null;
  }

  if (retryTimer) {
    clearTimeout(retryTimer);
  }

  // 清除定时刷新缓存定时器
  clearCacheRefreshTimer();

  if (!mqttConfig) {
    return;
  }

  request.postMicroserDess("/relay-ess/api/mqtt/removeCache", mqttConfig).then((res) => {
    console.log(res, "=====mqttStatistic removeCache=====");
  });
}

// 重连函数
function logReconnect(error) {
  console.log("mqttStatistic正在重连...", error);
}

// 连接失败
function logError(error) {
  store.commit("changeMqttStatus", false);
  console.log("mqttStatistic连接失败...", error);
}

// 连接断开
function logDisconnect() {
  store.commit("changeMqttStatus", false);
  console.log("mqttStatistic连接断开");
  if (cacheRetryTask && cacheRetryTask.abort) {
    cacheRetryTask.abort(); // 中止重试
    cacheRetryTask = null;
  }
  clearCacheRefreshTimer();
}

// 连接关闭
function logClose() {
  store.commit("changeMqttStatus", false);
  console.log("mqttStatistic连接关闭");
  clearCacheRefreshTimer();
}

// 客户端下线
function logOffline() {
  store.commit("changeMqttStatus", false);
  console.log("mqttStatistic客户端下线");
  if (cacheRetryTask && cacheRetryTask.abort) {
    cacheRetryTask.abort(); // 中止重试
    cacheRetryTask = null;
  }
  clearCacheRefreshTimer();
}

// 添加网络状态监听
function addNetworkListener() {
  // 监听网络状态变化
  window.addEventListener("online", handleNetworkOnline);
  window.addEventListener("offline", handleNetworkOffline);
}

// 删除网络状态监听
export function delStatisticNetworkListener() {
  // 移除网络监听器避免重复绑定
  window.removeEventListener("online", handleNetworkOnline);
  window.removeEventListener("offline", handleNetworkOffline);
}

// 网络连接恢复处理
function handleNetworkOnline() {
  console.log("网络已连接");
  networkStatus = true;
  // 网络恢复后尝试重连MQTT
  if (!client || !client.connected) {
    console.log("网络恢复，尝试重连mqttStatistic");
    reconnectMqtt();
  }
}

// 网络断开处理
function handleNetworkOffline() {
  store.commit("changeMqttStatus", false);
  console.log("网络已断开");
  networkStatus = false;
  // 网络断开时断开MQTT连接
  if (client && client.connected) {
    console.log("网络断开，关闭mqttStatistic连接");
    mqttStatisticDisconnect();
  }
}

// 重连MQTT
function reconnectMqtt() {
  if (reconnectTimer) {
    clearTimeout(reconnectTimer);
  }

  // 如果已经有连接，先断开
  if (client) {
    client.end(true);
    client = null;
  }

  reconnectTimer = setTimeout(() => {
    if (networkStatus && mqttConfig) {
      console.log("开始重连mqttStatistic");
      initMqttStatistic({
        pn: mqttConfig.pn,
        sn: mqttConfig.sn,
        devcode: mqttConfig.devcode,
        devaddr: mqttConfig.devaddr,
      });
    }
  }, 1000); // 延迟1秒重连，确保网络完全恢复
}
